const data = [
    {
        id: 1,
        completed: false,
        priority: "moon",
        title: "Bedroom",
        description: "Change sheets and pillow cases. Put away clothes, placing dirty items in the hamper and clean ones in their proper place."
    },
    {
        id: 2,
        completed: false,
        priority: "planet",
        title: "Grocery shopping !",
        description: "Visit the store tomorrow at 2 p.m. to buy fresh apples, bananas, broccoli, spinach, and potatoes."
    },
    {
        id: 3,
        completed: false,
        priority: "sun",
        title: "Work !!",
        description: "Email Sara the revised contract terms by Friday. " +
            "Complete all assignments by tomorrow to avoid missing the deadline."
    },
]

export default data
